import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoOficio, TipoOficioProps } from '../../interfaces/catalogos/TipoOficioInterface';

export const TipoOficios = () => {

    return new Promise<TipoOficioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoOficio/', token)
            .then( ({ data } : { data : TipoOficioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoOficio = () => {

    return new Promise<TipoOficioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoOficio/ObtenerTipoOficios', token)
            .then( ({ data } : { data : TipoOficioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoOficio = ( params: TipoOficioProps ) => {

    return new Promise<TipoOficioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoOficio/Actualizar', params, token)
            .then( ({ data } : { data : TipoOficioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoOficio } );
            });

        }

    });

}

export const AgregarTipoOficio = ( params: TipoOficioProps ) => {

    return new Promise<TipoOficioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoOficio/Agregar', params, token)
            .then( ({ data } : { data : TipoOficioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoOficio } );
            });

        }

    });

}
